import { LabelValue } from '@/lib/model';
import TabsListUnstyled from '@mui/base/TabsListUnstyled';
import TabsUnstyled from '@mui/base/TabsUnstyled';
import TabUnstyled from '@mui/base/TabUnstyled';
import * as React from 'react';
import './index.scss';

export interface TabsProps<T> {
  tabs: LabelValue<T>[];
  value: T;
  onTabChange: (value: T) => void;
}

export const Tabs = <T,>({ tabs, value, onTabChange }: TabsProps<T>) => {
  const valueIndex = tabs.findIndex(e => e.value === value) || 0;
  const onChange = (
    _event: React.SyntheticEvent<Element, Event>,
    value: string | number | boolean
  ) => {
    onTabChange(tabs[value as number].value);
  };

  return (
    <TabsUnstyled value={valueIndex} onChange={onChange}>
      <TabsListUnstyled className="TabList">
        {tabs.map((tab, i) => (
          <TabUnstyled className="Tab" key={i.toString()}>
            {tab.label}
          </TabUnstyled>
        ))}
      </TabsListUnstyled>
    </TabsUnstyled>
  );
};
